import { init as initApi, update as updateApi } from "../../service/EvaluationPeriodService";

//アクションタイプ定義
export const INIT = "EVALUATION_TERM_INIT";
export const UPDATE_SUCCESS = "EVALUATION_TERM_UPDATE_SUCCESS";
export const UPDATE_FAIL = "EVALUATION_TERM_UPDATE_FAIL";

export const init = () => dispatch => {
  initApi().then(response => {
    const evaluationTerms = response.evaluationTerms;
    const terms = evaluationTerms.map((term, index) => ({
      id: index,
      periodId: term.termId,
      periodName: term.termName,
      startingDate: term.startDate,
      registeredDate: term.createdDate,
      updatedDate: term.updatedDate
    }));
    dispatch({ type: INIT, payload: { row: terms } });
  });
};

export const update = param => dispatch => {
  updateApi(param)
    .then(() => {
      dispatch({ type: UPDATE_SUCCESS, payload: { params: param } });
      alert("評価期間を更新しました。");
    })
    .catch(error => {
      dispatch({ type: UPDATE_FAIL, payload: { message: "評価期間の更新中にエラーが発生しました。", error: error } });
      alert("評価期間の更新中にエラーが発生しました。");
    });
};
